import {
  apiClient
} from "./chunk-HCVPNQUB.mjs";

// src/ops/dlqApi.ts
import { DlqService } from "@maat/api-shared";
var DLQ_SERVICE_PATH = {
  [DlqService.Payment]: "/payment",
  [DlqService.Booking]: "/booking",
  [DlqService.Host]: "/main",
  [DlqService.Search]: "/search",
  [DlqService.Chat]: "/chat",
  [DlqService.Notifications]: "/notifications",
  [DlqService.Pricing]: "/pricing"
};
var base = (service) => `${DLQ_SERVICE_PATH[service]}/api/admin/dlq`;
var dlqApi = {
  getSummary: async (service) => apiClient.get(base(service)),
  getMessages: async (service, queue) => apiClient.get(
    `${base(service)}/${encodeURIComponent(queue)}/messages`
  ),
  redrive: async (service, queue, messageId) => apiClient.post(
    `${base(service)}/${encodeURIComponent(queue)}/redrive`,
    { messageId }
  ),
  discard: async (service, queue, messageId) => apiClient.delete(
    `${base(service)}/${encodeURIComponent(queue)}/messages/${encodeURIComponent(messageId)}`
  )
};

export {
  dlqApi
};
